// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./sass/detail/detail_slider.scss
// module id = 93
// module chunks = 0